export default __webpack_public_path__ + "static/media/mapiiit.faeaee0e.png";